// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"29e0a038","316":"bfba6caa","488":"9d639d49","579":"4edccbd1","860":"f0a9663e","952":"8cfed0d5","976":"4f64ced5"}[chunkId] + ".css";
};